import { Avatar, Dropdown, Menu, Input, Pagination, Select, Tag } from "antd";
import { useState, useMemo } from "react";
import totalEmp from "../../../imgs/totalEmp.png";
import empLeft from "../../../imgs/empOff.png";
import empAct from "../../../imgs/currEmp.png";
import { useNavigate } from "react-router-dom";
import AwardCards from "./components/AwardCards";
import AttendanceTable from "../attendance/components/AttendanceTable";
import EmployeTable from "../employees/components/EmployeTable";
import { EmployeeData } from "../../../constants/EmployeesData";
import AddCertificate from "./components/Certificate";
import cerImg from "../../../imgs/CertificateSample.png";

import Button from "../components/Button";
import D1 from "../../../imgs/D1.jpg";
import D2 from "../../../imgs/D2.jpg";
import D3 from "../../../imgs/D3.jpg";
import D4 from "../../../imgs/D4.jpg";
import D5 from "../../../imgs/D5.jpg";
import { useDispatch, useSelector } from "react-redux";

const { Option } = Select;

const columns = [
  { title: "ID", key: "id" },
  {
    title: "Name",
    key: "name",
    render: (name, row) => (
      <div className="flex items-center">
        <Avatar
          src={row.profile}
          className="border-2 border-primary mr-2 w-10 h-10"
        />
        <p className="text-primary capitalize">{name}</p>
      </div>
    ),
  },
  { title: "Position", key: "position" },
  { title: "Department", key: "department" },
  { title: "Rate", key: "rate" },
  { title: "Address", key: "address" },
  { title: "Contact", key: "contact" },
  { title: "Marital Status", key: "maritalStatus" },
  { title: "Gender", key: "gender" },
];

const dummyData = [
  {
    id: "1",
    profile: "profile1.jpg", // Replace with actual profile image path
    employeeName: "John Doe",
    awardTitle: "Employee of the Month",
    awardType: "Performance",
    department: "IT",
    awardDate: "2024-11-01",
    reason: "Exceptional performance in project delivery",
    status: "Active",
  },
  {
    id: "2",
    profile: "profile2.jpg",
    employeeName: "Jane Smith",
    awardTitle: "Team Player Award",
    awardType: "Collaboration",
    department: "HR",
    awardDate: "2024-10-15",
    reason: "Outstanding collaboration with cross-functional teams",
    status: "Active",
  },
  {
    id: "3",
    profile: "profile3.jpg",
    employeeName: "Michael Johnson",
    awardTitle: "Innovation Award",
    awardType: "Creativity",
    department: "R&D",
    awardDate: "2024-09-30",
    reason: "Developing an innovative solution for a critical issue",
    status: "Pending",
  },
  {
    id: "4",
    profile: "profile4.jpg",
    employeeName: "Emily Davis",
    awardTitle: "Customer Excellence",
    awardType: "Service",
    department: "Support",
    awardDate: "2024-08-25",
    reason: "Achieving the highest customer satisfaction scores",
    status: "Active",
  },
  {
    id: "5",
    profile: "profile5.jpg",
    employeeName: "Chris Brown",
    awardTitle: "Best Designer",
    awardType: "Creativity",
    department: "Design",
    awardDate: "2024-07-20",
    reason: "Exceptional creativity in design projects",
    status: "Revoked",
  },
  {
    id: "6",
    profile: "profile6.jpg",
    employeeName: "Sarah Wilson",
    awardTitle: "Leadership Award",
    awardType: "Leadership",
    department: "Management",
    awardDate: "2024-06-10",
    reason: "Inspiring leadership during challenging times",
    status: "Active",
  },
];

const DevicesMain = () => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const router = useNavigate();
  const transactionType = useSelector((state) => state.transactionType);
  const [searchTerm, setSearchTerm] = useState("");
  const [locationSelected, setLocationSelected] = useState("");
  const [departmentSelected, setDepartmentSelected] = useState("");
  const [addCertificate, setAddCertificate] = useState(false);
  const handleSearch = (e) => setSearchTerm(e.target.value);
  const handleLocationChange = (value) => setLocationSelected(value);
  const handleDepartmentChange = (value) => setDepartmentSelected(value);

  const filteredData = useMemo(() => {
    return dummyData.filter((record) => {
      const matchesLocation = locationSelected
        ? record.location === locationSelected
        : true;
      const matchesDepartment = departmentSelected
        ? record.department === departmentSelected
        : true;
      const matchesSearch = record.employeeName
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase());
      return record && matchesLocation && matchesDepartment && matchesSearch;
    });
  }, [searchTerm, locationSelected, departmentSelected]);

  const handleAction = (action, id) => {
    switch (action) {
      case "view":
        // router(`/Devices/DeviceDetails`);
        break;
      case "edit":
        console.log(`Edit details for employee ID: ${id}`);
        // router(`/Devices/1`);

        break;
      case "remove":
        // console.log(`Remove employee ID: ${id}`);
        break;
      default:
        console.log("Unknown action");
    }
  };

  // Action menu for each row
  const actionMenu = (id) => (
    <Menu>
      <Menu.Item key="1" onClick={() => handleActionEmployee("view", id)}>
        View
      </Menu.Item>
      <Menu.Item key="2" onClick={() => handleAction("edit", id)}>
        Issue Award
      </Menu.Item>
      {/* <Menu.Item key="3" onClick={() => handleAction("remove", id)}>
        Remove
      </Menu.Item> */}
    </Menu>
  );

  const handleActionEmployee = (action, id) => {
    switch (action) {
      case "view":
        router(`/EmployeeDetails`);
        break;
      case "edit":
        router(`/Employee/1`);
        console.log(`Edit details for employee ID: ${id}`);
        break;
      case "remove":
        console.log(`Remove employee ID: ${id}`);
        break;
      default:
        console.log("Unknown action");
    }
  };

  const columnHeaders = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },

    {
      title: "Employee Name",
      dataIndex: "employeeName",
      key: "employeeName",
      render: (name, row) => (
        <div className="flex items-center">
          <Avatar
            src={
              "https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg"
            }
            className="border-2 border-primary mr-2 w-10 h-10"
          />
          <p className="text-primary capitalize">{name}</p>
        </div>
      ),
    },
    {
      title: "Award Title",
      dataIndex: "awardTitle",
      key: "awardTitle",
    },
    {
      title: "Award Type",
      dataIndex: "awardType",
      key: "awardType",
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
    },
    {
      title: "Award Date",
      dataIndex: "awardDate",
      key: "awardDate",
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const statusColors = {
          Active: "green",
          Pending: "yellow",
          Revoked: "red",
        };

        return (
          <Tag
            color={statusColors[status] || "gray"}
            className="text-xs font-normal px-2 py-1"
          >
            {status}
          </Tag>
        );
      },
    },
    {
      title: "File",
      dataIndex: "file",
      key: "file",
      render: (name, row) => (
        <div
          className="flex items-center cursor-pointer"
          onClick={() => {
            setShow(true);
          }}
        >
          <img
            src="data:image/png;base64,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"
            className=" mr-2 w-25 h-8"
          />
          {/* <p className="text-primary capitalize">{name}</p> */}
        </div>
      ),
    },
  ];

  const Tabs = [
    {
      key: "program",
      label: "Awards",
      component: (
        <AttendanceTable
          columns={columnHeaders}
          data={filteredData}
          pageSize={10}
          //   actions={actionMenu}
        />
      ),
    },
    {
      key: "general",
      label: "Employees",
      component: (
        <EmployeTable
          columns={columns}
          data={EmployeeData}
          pageSize={5}
          onAction={handleActionEmployee}
          actions={actionMenu}
        />
      ),
    },
  ];

  return (
    <div className="h-full p-4">
      <div className="flex w-full justify-between">
        <h2 className="text-xl font-semibold">Awards</h2>
        <Button className="rounded-md" onClick={() => setAddCertificate(true)}>
          Issue Certificate
        </Button>
      </div>
      <div style={{ margin: "20px 0px 20px 0px" }}>
        <AwardCards />
      </div>

      <div className=" sm:px-12 mt-6 sm:mt-7 m-5  flex items-center justify-center">
        <div className="grid grid-cols-2 gap-0 ">
          {Tabs.map((tab) => (
            <button
              className={`${
                tab.key === transactionType
                  ? "border-primary bg-primary font-semibold text-white rounded-t-lg"
                  : "text-[#B7B7B7] bg-[#ECECEC] font-semibold rounded-tr-lg"
              }  p-2  text-[0.9rem] shadow-md flex items-center justify-center px-16 `}
              onClick={() =>
                dispatch({ type: "TRANSACTION_TYPE", num: tab.key })
              }
            >
              {tab.label}
            </button>
          ))}
        </div>{" "}
      </div>
      <div
        className={`${
          transactionType === "general"
            ? "hidden"
            : "grid gap-4 grid-cols-5 mb-4 mt-5"
        }`}
      >
        <Input
          placeholder="Search by name"
          value={searchTerm}
          onChange={handleSearch}
          className="w-full h-[32px]"
        />
        {/* <Select
          placeholder="Location"
          onChange={handleLocationChange}
          className="w-full h-[32px]"
          allowClear
        >
          {Array.from(new Set(dummyData.map((data) => data.location))).map(
            (location) => (
              <Option key={location} value={location}>
                {location}
              </Option>
            )
          )}
        </Select> */}
        <Select
          placeholder="Department"
          onChange={handleDepartmentChange}
          className="w-full h-[32px]"
          allowClear
        >
          {Array.from(new Set(dummyData.map((data) => data.department))).map(
            (department) => (
              <Option key={department} value={department}>
                {department}
              </Option>
            )
          )}
        </Select>
      </div>

      <div className="mt-6">
        {Tabs.find((tab) => tab.key === transactionType)?.component}
      </div>
      {addCertificate && <AddCertificate setShow={setAddCertificate} />}

      <div
        className={`${
          show
            ? "w-full h-full fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center z-10"
            : "hidden"
        } `}
      >
        <div className="relative p-4 w-full max-w-3xl max-h-[94%]">
          <div className="relative bg-white rounded-lg shadow ">
            <div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t ">
              <h3 className="text-lg font-semibold text-gray-900 ">
                Certificate
              </h3>
              <button
                onClick={() => setShow(false)}
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm h-8 w-8 ms-auto inline-flex justify-center items-center  "
                data-modal-toggle="select-modal"
              >
                <svg
                  className="w-3 h-3"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 14 14"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                  />
                </svg>
                <span className="sr-only">Close modal</span>
              </button>
            </div>

            <img src={cerImg} alt="voucher" className="w-full h-[20rem] p-3 object-fill" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevicesMain;
